import { tenant } from './tenant';

const {
    ENV: { 
        ILLINOIS,
        OKLAHOMA,
        ARKANSAS,
        ARKANSAS_GOV,
        MISSISSIPPI,
        SALES
    }
} = tenant;

const COMMON_PATHS = {
    LOCAL_HOST: {
        api: 'https://localhost:8181',
        app: 'https://localhost:9191'
    },
    TEST: {
        api: 'http://test',
        app: 'http://test'
    },
    PAGE_NOT_FOUND_PATH: '/404',
    CONSTITUENT_CREATE_ACCOUNT: '/authenticate/create-account?tenant={mspTenantId}',
    CONSTITUENT_VERIFY_ACCOUNT: '/authenticate/verify-account?tenant={mspTenantId}',
    CONSTITUENT_FORGOT_USERNAME: '/authenticate/forgot-username?tenant={mspTenantId}',
    CONSTITUENT_REDIRECT_SIGN_IN: '/authenticate/validate',
    CONSTITUENT_REDIRECT_SIGN_OUT: '/login',
    AGENCY_LOGIN: '/management?tenant={mspTenantId}',
    APPLICATION: '/authenticate/{vanityUrl}'
};

const ELP_PATHS = {
    ELP_QA: {
        api: 'https://qa.lnpweb.com', 
        app: 'https://qa.lnpweb.com' 
    },
    ELP_DEV: {
        api: 'https://dev.lnpweb.com', 
        app: 'https://dev.lnpweb.com' 
    },
    ELP_UAT: {
        api: 'https://uat.lnpweb.com',
        app: 'https://uat.lnpweb.com'
    },
    ELP_STG: {
        api: 'https://stg.lnpweb.com',
        app: 'https://stg.lnpweb.com'
    },
    ELP_PROD: {
        api: 'https://lnpweb.com',
        app: 'https://lnpweb.com'
    },
    ELP_NIC_STG: {
        api: 'https://apps-stg.lnpweb.com',
        app: 'https://apps-stg.lnpweb.com'
    },
    ELP_NIC_PROD: {
        api: 'https://apps.lnpweb.com',
        app: 'https://apps.lnpweb.com'
    }
};

const ELP_GOV_PATHS = {
    ELP_GOV_DEV: {
        api: 'https://dev.elp.egov.com',
        app: 'https://dev.elp.egov.com'
    },
    ELP_GOV_STG: {
        api: 'https://stg.elp.egov.com',
        app: 'https://stg.elp.egov.com'
    },
    ELP_GOV_PROD: {
        api: 'https://apps.elp.egov.com',
        app: 'https://apps.elp.egov.com'
    }
};

const ILLINOIS_PATHS = {
    [ILLINOIS.DEV]: ELP_PATHS.ELP_DEV,
    [ILLINOIS.QA]: ELP_PATHS.ELP_QA,
    [ILLINOIS.UAT]: ELP_PATHS.ELP_UAT,
    [ILLINOIS.STG]: ELP_PATHS.ELP_STG,
    [ILLINOIS.PROD]: ELP_PATHS.ELP_PROD
};

const OKLAHOMA_PATHS = {
    [OKLAHOMA.DEV]: ELP_PATHS.ELP_DEV
};

const ARKANSAS_PATHS = {
    [ARKANSAS.STG]: ELP_PATHS.ELP_NIC_STG,
    [ARKANSAS.PROD]: ELP_PATHS.ELP_NIC_PROD
};

const ARKANSAS_GOV_PATHS = {
    [ARKANSAS_GOV.DEV]: ELP_GOV_PATHS.ELP_GOV_DEV,
    [ARKANSAS_GOV.STG]: ELP_GOV_PATHS.ELP_GOV_STG,
    [ARKANSAS_GOV.PROD]: ELP_GOV_PATHS.ELP_GOV_PROD
};

const MISSISSIPPI_PATHS = {
    [MISSISSIPPI.STG]: ELP_PATHS.ELP_NIC_STG,
    [MISSISSIPPI.PROD]: ELP_PATHS.ELP_NIC_PROD
};

const SALES_PATHS = {
    [SALES.STG]: ELP_PATHS.ELP_NIC_STG
};

export const path = {
    ELP_GOV_PATHS: {
        ...ELP_GOV_PATHS,
        ...ARKANSAS_GOV_PATHS
    },
        ...COMMON_PATHS,
        ...ELP_PATHS,
        ...ILLINOIS_PATHS,
        ...OKLAHOMA_PATHS,
        ...ARKANSAS_PATHS,
        ...MISSISSIPPI_PATHS,
        ...SALES_PATHS,
        ...ELP_GOV_PATHS
};



// WEBPACK FOOTER //
// ./src/common/constants/path.js